import { StrictMode } from 'react'

import { Buffer } from 'buffer'

import { Notifications } from '@mantine/notifications'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { MantineProvider } from '@mantine/core'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import { persistor, store } from 'src/Redux'
import { SentryProvider } from 'src/Components/SentryProvider'
import './index.css'

import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/dates/styles.css'

import App from './App.tsx'

globalThis.Buffer = Buffer

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SentryProvider>
          <BrowserRouter>
            <MantineProvider>
              <Notifications />
              <App />
            </MantineProvider>
          </BrowserRouter>
        </SentryProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
)
